import React, { useState } from "react";
import { useTransition, animated } from "react-spring";

export const IsCalcon = ({ formData, setForm, navigation, step }) => {
  const loanReason = [
    { id: "Refinance", title: "Refinance" },
    { id: "Purchase", title: "Buy a Home" },
    { id: "Construction - Perm", title: "Build a Home" },
  ];

  // console.log(formData);
  // console.log(formData.loanReason);
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const changePath = () => {
    if (formData.loanReason === "") {
      setError(true);
      console.log("error");
    }
    if (formData.loanReason === "Construction - Perm") {
      navigation.go(2);
    } else if (formData.loanReason === "Purchase") {
      navigation.go(12);
    } else if (formData.loanReason === "Refinance") {
      navigation.go(20);
    }
  };

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-start mt-24 h-full">
        {transition((style, item) =>
          item ? (
            <animated.div style={style}>
              <div className="flex justify-end py-4 pb-8">
                <button
                  className="bg-gray-light py-1 px-14 text-grey-eighty text-md transition-all w-58 cursor-pointer"
                  onClick={() => navigation.go(0)}
                >
                  Start Over
                </button>
              </div>
              <div className="mx-auto flex flex-col justify-end items-center">
                <h1 className=" text-4xl text-blue-primary font-semibold mb-6 md:mb-10 text-center">
                  Is CalCon Mutual Mortgage indicated as the servicer on your
                  "Notice of Servicing Transfer" letter?
                </h1>

                <div className="py-6 flex flex-col md:flex-row justify-evenly md:space-x-8 space-y-8 md:space-y-0">
                  <div>
                    <button
                      className="hover:bg-blue-dark hover:outline-blue-dark bg-blue-complimentary py-1 px-14 text-white font-semibold text-xl outline-blue-complimentary outline-2 outline outline-offset-6 transition-all w-52 cursor-pointer"
                      onClick={() => navigation.go(3)}
                    >
                      Yes
                    </button>
                  </div>
                  <div>
                    <button
                      className="hover:bg-blue-dark hover:outline-blue-dark bg-blue-complimentary py-1 px-14 text-white font-semibold text-xl outline-blue-complimentary outline-2 outline outline-offset-6 transition-all w-52 cursor-pointer"
                      onClick={() => navigation.go(4)}
                    >
                      No
                    </button>
                  </div>
                  <div>
                    <button
                      className="hover:bg-blue-dark hover:outline-blue-dark bg-blue-complimentary py-1 px-14 text-white font-semibold text-xl outline-blue-complimentary outline-2 outline outline-offset-6 transition-all w-52 cursor-pointer"
                      onClick={() => navigation.go(5)}
                    >
                      Not sure
                    </button>
                  </div>
                </div>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
    </div>
  );
};
